import React, { useState, useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import CdxModal from './shared/modal/CdxModal';

const RouteLeavingGuard = (props) => {
    let history = useHistory();
    const [modalVisible, setModalVisible] = useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
    const [lastLocation, setLastLocation] = useState(null);

    useEffect(() => {
        // console.log('RouteLeavingGuard:', confirmedNavigation, lastLocation);
        if (confirmedNavigation && lastLocation) {
            history.push(lastLocation.pathname);
        }
    }, [confirmedNavigation, lastLocation]);

    useEffect(() => {
        // console.log('RouteLeavingGuard: ', props.resetGuard);
        setConfirmedNavigation(false);
        closeModal();
    }, [props.resetGuard]);

    const showModal = (location) => {
        setModalVisible(true);
        setLastLocation(location);
    };

    const closeModal = () => {
        setModalVisible(false);
    };

    const handleBlockedNavigation = (nextLocation) => {
        if (!confirmedNavigation) {
            showModal(nextLocation);
            return false;
        }
        return true;
    };

    // const handleConfirmNavigationClick = () => {
    //     setConfirmedNavigation(true);
    //     setModalVisible(false);
    // };

    return (
        <>
            <Prompt when={props.when} message={handleBlockedNavigation} />

            <CdxModal
                show={modalVisible}
                onHide={() => closeModal()}
                onClose={() => closeModal()}
                noBorder={false}
            >
                <CdxModal.Header>Warning</CdxModal.Header>
                <CdxModal.Body>
                    {props.message}
                </CdxModal.Body>
                <CdxModal.Footer>
                    <button className="cdx-btn" onClick={() => { setModalVisible(false); props.onConfirm(lastLocation); }}>Confirm</button>
                    <button className="cdx-btn" onClick={() => closeModal()}>Cancel</button>
                </CdxModal.Footer>
            </CdxModal>
        </>
    );

};

export default RouteLeavingGuard;